import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {api} from "../utils/gashtaltAPI";
import '../assets/css/Entrance.css'
import {toPersianNumber, toEnglishNumber} from '../utils/numberConversion';
import Image from '../assets/images/index.svg'
import {useDispatch, useSelector} from "react-redux";
import OtpInput from "../components/OTPInput";
import {verifyUser} from "../store/userSlice";

function VerifyOTP() {
    const {user} = useSelector((state) => state.user);
    const [otp, setOtp] = useState("");
    const [seconds, setSeconds] = useState(0);
    const [isRunning, setIsRunning] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleOtpChange = (value) => {
        setOtp(value);
    };
    useEffect(() => {
        if (!isRunning) return;
        if (seconds <= 0) setIsRunning(false)
        const interval = setInterval(() => {
            setSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);

        return () => {clearInterval(interval)}; // Cleanup interval on unmount or when stopped
    }, [isRunning, seconds]);
    const sendOTP = async () => {
        try {
            const response = await api.get("/api/sendOTP")
            const data = response.data;
            if (data.success) {
                toast.success(data.message, {
                    position: "bottom-right"
                });
            }else
                toast.info(data.message, {
                    position: "bottom-right"
                });
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 422 || status === 401) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    useEffect(() => {
        if (user.verified)
            navigate("/panel");
        else {
            setIsRunning(true);
            setSeconds(120);
            sendOTP()
        }
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post("/api/checkOTP", {
                code: toEnglishNumber(otp)
            })
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            dispatch(verifyUser());
            navigate('/panel')
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    };
    return (
        <>
            <div className="entrance-panel row">
                <div className="col-lg-6 form-div d-flex flex-column justify-content-center">
                    <h3>
                        کد پیامک شده به شماره
                        <span className="phone-number">{toPersianNumber(user.phone_number)}</span>
                        را وارد کنید.
                    </h3>
                    <form method="post" className="container" onSubmit={handleSubmit}>
                        <div className="custom-input-group col-12 col-lg-8">
                            <OtpInput length={6} onChange={handleOtpChange}/>
                        </div>
                        <button
                            className="submit-button btn btn-filled col-12 col-lg-8 mb-2"
                            type="submit" disabled={isRunning} onClick={(e)=>{e.preventDefault(); sendOTP();}}
                        >
                            {isRunning ? `زمان باقی مانده : ${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}` : 'ارسال مجدد'}
                        </button>
                        <button className="submit-button btn btn-filled col-12 col-lg-8" type="submit">بررسی</button>
                    </form>
                </div>
                <div className="image-div col-6 hide-on-mobile">
                    <img src={Image} alt="خطا"/>
                </div>
            </div>
        </>
    );
}

export default VerifyOTP;
